import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import titre from './linkeven.png';
import appstore from './appstore.png';
import googleplay from './googleplay.png';
import depenses from './screen11.png';
import frame from './qr-code.svg';
import './App.css';
import { useState, useEffect } from 'react';
import Error403 from './components/Error403';
import Error404 from './components/Error404';
import DeleteAccount from './components/DeleteAccount';
import ExpenseFeature from './components/ExpenseFeature';
import NoteFeature from './components/NoteFeature';
import SurveyFeature from './components/SurveyFeature';
import DeviseFeature from './components/DeviseFeature';
import StatFeature from './components/StatFeature';
import TicketFeature from './components/ticketFeature';
import CodeRedirect from './components/CodeRedirect';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { fr } from './locales/fr';
import { en } from './locales/en';
import { us } from './locales/us';
import ecran2 from './ecran5.png';
import ecran1 from './ecran1.png';
import ticket from './ticket4.png';
import people from './people1.png';

function MainApp() {
  const location = useLocation();
  const navigate = useNavigate();

  // 1. Définition du dictionnaire de langues
  const translations = {
    '/fr': fr,
    '/en': en,
    '/us': us
  };

  // 2. Sélection de la langue (par défaut 'us' ou 'en' si rien ne correspond)
  const t = translations[location.pathname] || us;

  // 3. Détection automatique de la langue au premier chargement
  useEffect(() => {
    // On ne redirige que si on est sur la racine "/"
    console.log(location)
    if (location.pathname === '/') {
      const userLang = navigator.language || navigator.userLanguage;
      
      if (userLang.startsWith('fr')) {
        navigate('/fr', { replace: true });
      } else {
        navigate('/en', { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    const handleResize = () => {
      setScreenHeight(window.innerHeight); // Met à jour la hauteur de l'écran
      checkIfMobile();
    };

    // Vérification initiale
    handleResize();

    // Ajout du listener pour les changements de taille d'écran
    window.addEventListener('resize', handleResize);

    // Nettoyage du listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fonction pour détecter iOS et macOS
  const isAppleDevice = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod|macintosh|mac os/.test(userAgent);
  };

  // Fonction pour gérer le clic sur le bouton de téléchargement
  const handleDownloadClick = () => {
    const appStoreUrl = "https://apps.apple.com/fr/app/linkount/id6737286047";
    const playStoreUrl = "https://play.google.com/store/apps/details?id=linkount.com";
    
    window.open(isAppleDevice() ? appStoreUrl : playStoreUrl, '_blank');
  };

  return (
    <div className="App" style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      background: 'black',
      position: 'relative',
      overflow: 'hidden'
    }}>

      {/* Éléments décoratifs d'arrière-plan */}
      <div style={{
        position: 'absolute',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        background: 'black',
        top: '-200px',
        right: '-200px',
        zIndex: 0
      }} />
      <div style={{
        position: 'absolute',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'black',
        bottom: '100px',
        left: '-100px',
        zIndex: 0
      }} />
      {!isMobile && 
      <div>
            {/* Header avec fond flou */}
        <header style={{
        position: 'fixed',
        backdropFilter: 'blur(30px)',
        background: 'rgba(255, 255, 255, 0.1)',
        padding: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center', // Espace entre le titre et le bouton
        zIndex: 4,
        width: '100%',
        borderBottom: '0.2px solid rgba(255, 255, 255, 0.3)',
      }}>
        <div style={{
          display: 'flex',
          maxWidth: '1200px',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 40px'
        }}>
        {/* Image titre à gauche */}
        <img 
          src={titre} 
          alt="titre" 
          style={{
            width: 200,
            height: "auto",
          }}
        />
        
        {/* Conteneur pour le bouton à droite */}
        <button 
          onClick={handleDownloadClick}
          style={{
            background: 'rgba(255, 255, 255, 0.1)',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '20px',
            padding: '15px 40px',
            cursor: 'pointer',
            marginRight: 50,
            transition: 'all 0.3s ease',
            backdropFilter: 'blur(10px)',
            color: '#ffffff',
            fontSize: '1.3rem',
            fontFamily: 'Poppins-Medium',
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            marginLeft: 'auto', // Pousse le bouton à droite
            filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.2))',
          }}
          onMouseOver={e => {
            e.currentTarget.style.transform = 'translateY(-3px)';
            e.currentTarget.style.filter = 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.3))';
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.filter = 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.2))';
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
          }}
        >
          <img 
            src={isAppleDevice() ? appstore : googleplay} 
            alt="Télécharger" 
            style={{
              width: 35,
              height: 'auto',
            }}
          />
          {t.btn_start}
        </button>
        </div>
      </header>
      </div>
      }
      <header className="App-header" style={{ 
        flex: 1, 
        paddingBottom: '10px',
        position: 'relative',
        zIndex: 2
      }}>
        {isMobile &&
        <div style={{backdropFilter: 'blur(30px)', marginTop: 50, padding: 8, borderRadius: 20}}>
                <img 
          src={titre} 
          alt="titre" 
          style={{
            width: 300, // Ajustez la taille ici
            height: "auto",

          }}
        />
        </div>
        }
        {/* Logo avec effet de brillance et textes */}
        <div style={{
          padding: '10px',
          marginTop: !isMobile ? '130px' : '10px',
          alignItems: 'center',
        }}>
     
          {/* Container pour la description et l'image */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginTop: !isMobile ? 100 : 20,
            width: '100%',
            maxWidth: '1200px',
            padding: '0 0px',
          }}>
            {/* Conteneur gauche (texte + SVG) */}
            <div style={{ flex: '1', marginLeft: 20, marginRight: 20 }}>
              <div style={{ 
                marginBottom: '30px',
                marginLeft: !isMobile ? screenHeight / 20 : 20,
                marginTop: 0,
                marginRight: !isMobile ? screenHeight / 20 : 20,
                textAlign: 'left',
                justifyContent: 'start',
                paddingLeft: 20,
                backdropFilter: 'blur(50px)',
                borderRadius: 20,
              }}>
                <h1 style={{
                  color: '#ffffff',
                  fontSize: !isMobile ? screenHeight / 20 : 25,
                  marginBottom: 10,
                  textAlign: 'start',
                  padding: 10,
                  filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.2))'
                }}>
                  {t.hero_title1}
                  <span style={{ fontSize: !isMobile ? screenHeight / 19 : 26, color: 'rgb(119, 185, 252)' }}>
                  {t.hero_title2}
                </span>
                  {t.hero_title3}
                  <span style={{ fontSize: !isMobile ? screenHeight / 19 : 26, color:  'rgb(199, 193, 252)'}}>
                  {t.hero_title4}
                </span>
                {t.hero_title7}
                <span style={{ fontSize: !isMobile ? screenHeight / 19 : 26, color: 'rgb(242, 191, 255)' }}>
                  {t.hero_title8}
                </span>

                </h1>

              </div>

              <div style={{}}>
              <img 
                  src={people}
                  alt="people"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: '0',
                    width: '100%',
                    height: '110vh', // Ou 20% selon le parent
                    objectFit: 'cover',
                    objectPosition: 'top',
                    zIndex: -1,
                    opacity: 0.9,
                    filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.2))',
                    pointerEvents: 'none'
                  }}
                />
                </div>
              {/* Frame SVG */}
              {!isMobile && (
                <div style={{
                  width: '25%',
                  padding: '10px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '20px',
                  backdropFilter: 'blur(10px)',
                  margin: '0 auto',
                  marginLeft: screenHeight / 3.4,
                  display: 'flex',
                  justifyContent: 'center',
                  transition: 'transform 0.3s ease',
                  filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.1))',
                }}
                onMouseOver={e => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseOut={e => {
                  e.currentTarget.style.transform = 'scale(1)';
                }}>
                  {/* IMAGE 1 : ecran1.png (Décalée en haut à gauche) */}




                  <img 
                    src={frame} 
                    alt="frame"
                    style={{
                      width: '100%',
                      height: 'auto',
                      pointerEvents: 'none',
                      filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.1))',
                      borderRadius: '12px'
                    }}
                  />
                </div>
              )}
            </div>
            {/* Image à droite */}
            {!isMobile && (
              <div style={{
                flex: '0 0 20%',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '25px',
                padding: '15px',
                marginRight: screenHeight / 10,
                backdropFilter: 'blur(10px)',
                display: 'flex',
                transition: 'transform 0.3s ease',
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'scale(1)';
              }}>
              
                <img 
                  src={depenses} 
                  alt="Aperçu de l'application"
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '15px',
                    filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.1))'
                  }}
                />
              </div>
            )}
   
          </div>
        </div>

        {/* Bouton de téléchargement pour mobile */}
        {isMobile && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 40,
            marginBottom: 40,
            padding: '0 20px'
          }}>
            <button 
              onClick={handleDownloadClick}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '2px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '20px',
                padding: '15px 40px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)',
                color: '#ffffff',
                fontSize: '1.3rem',
                fontFamily: 'Poppins-Medium',
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.2))',
                width: '100%',
                maxWidth: '400px',
                justifyContent: 'center'
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.filter = 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.3))';
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.filter = 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.2))';
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              }}
            >
              <img 
                src={isAppleDevice() ? appstore : googleplay} 
                alt="Télécharger" 
                style={{
                  width: 35,
                  height: 'auto',
                }}
              />
              {t.btn_start}
            </button>
          </div>
        )}

        {/* Section liste de fonctionnalités détaillées */}
        <TicketFeature isMobile={isMobile} t={t}/>
        <ExpenseFeature isMobile={isMobile} t={t}/>
        <NoteFeature isMobile={isMobile} t={t}/>
        <SurveyFeature isMobile={isMobile} t={t}/>
        <DeviseFeature isMobile={isMobile} t={t}/>
        <StatFeature isMobile={isMobile} t={t}/>

        {/* Section tableau comparatif */}
        <section 
          className="comparison-section" 
          style={{
            marginTop: 200,
            marginBottom: 40,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <div style={{
            maxWidth: '1200px',
            width: '100%',
            padding: '0 20px',
            alignItems: 'center'
          }}>
          <h2 style={{
            textAlign: 'center',
            marginBottom: 40,
            padding: '0 40px',
            fontSize: isMobile ? '1.4rem' : '2.4rem',
            fontFamily: 'Poppins-Medium',
            color: '#f9fafb',
            filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.2))'
          }}>
            {t.whyLinkount}
          </h2>

            <div className="comparison-table-wrapper">
              <table className="comparison-table">
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ fontSize: '1.05rem' }}>Linkeven</th>
                    <th style={{ fontSize: '1.05rem' }}>Tricount</th>
                    <th style={{ fontSize: '1.05rem' }}>Splitwise</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{t.addExpense}</td>
                    <td>✅</td>
                    <td>✅</td>
                    <td>❌</td>
                  </tr>
                  <tr>
                    <td>{t.statExpense}</td>
                    <td>✅</td>
                    <td>✅</td>
                    <td>
                      <span style={{ display: 'inline-block', lineHeight: 1.2 }}>
                        🟡
                        <br />
                        <span style={{ fontSize: '0.75rem' }}>Premium</span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>{t.addTicket}</td>
                    <td>✅</td>
                    <td>❌</td>
                    <td>
                      <span style={{ display: 'inline-block', lineHeight: 1.2 }}>
                        🟡
                        <br />
                        <span style={{ fontSize: '0.75rem' }}>Premium</span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>{t.calculdebt}</td>
                    <td>✅</td>
                    <td>❌</td>
                    <td>❌</td>
                  </tr>
                  <tr>
                    <td>{t.shareNote}</td>
                    <td>✅</td>
                    <td>❌</td>
                    <td>❌</td>
                  </tr>
                  <tr>
                    <td>{t.pool}</td>
                    <td>✅</td>
                    <td>❌</td>
                    <td>❌</td>
                  </tr>
                  <tr>
                    <td>{t.multiDevise}</td>
                    <td>
                      <span style={{ display: 'inline-block', lineHeight: 1.2 }}>
                        ✅
                        <br />
                        <span style={{ fontSize: '0.75rem' }}>{t.Devises}</span>
                      </span>
                    </td>
                    <td>✅</td>
                    <td>✅</td>
                  </tr>
                  <tr>
                    <td>{t.conversion}</td>
                    <td>✅</td>
                    <td>✅</td>
                    <td>
                      <span style={{ display: 'inline-block', lineHeight: 1.2 }}>
                        🟡
                        <br />
                        <span style={{ fontSize: '0.75rem' }}>Premium</span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <footer style={{
        width: '100%',
        textAlign: 'center',
        padding: '20px 0',
        marginTop: '100px',
      }}>
        <a 
          href="mailto:contact@linkevenapp.com" 
          style={{ 
            fontFamily: 'Poppins-Medium', 
            color: '#e0e7ff', 
            textDecoration: 'none', 
            fontSize: 15,
            transition: 'text-shadow 0.3s ease',
          }}
          onMouseOver={e => {
            e.currentTarget.style.textShadow = '0 0 20px rgba(255, 255, 255, 0.5)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.textShadow = 'none';
          }}
        >
          contact@linkevenapp.com
        </a>
      </footer>
      </header>

      
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/fr" element={<MainApp />} />
        <Route path="/en" element={<MainApp />} />
        <Route path="/us" element={<MainApp />} />
        <Route path="/403" element={<Error403 />} />
        <Route path="/404" element={<Error404 />} />
        <Route path="/code/:code" element={<CodeRedirect />} />
        <Route path="/deleteaccount" element={<DeleteAccount />} />
        <Route path="/:code" element={<CodeRedirect />} /> {/* Route dynamique pour les codes (doit être avant la route catch-all) */}
        <Route path="*" element={<Error404 />} /> {/* Pour toutes les routes non définies */}
      </Routes>
    </Router>
  );
}

export default App;
